import {connect} from 'react-redux';
import {Component} from 'react';

import {ControlGroup} from '-/components/fields/Control';
import {isMobile} from '-/util/util';
import Form from '-/components/fields/Form';
import {RadioGroup, Radio} from '-/components/fields/RadioGroup';
import Legend from '-/components/fields/Legend';
import ApiService from '-/services/ApiService';
import NavigationService from '-/services/NavigationService';
import BuyerInfoService from '-/services/BuyerInfoService';
import CreditorService from '-/services/CreditorService';
import UIService from '-/services/UIService';
import Step from '-/components/general/Step';

class PriorMembership extends Component {
    componentDidMount() {
        const {priorMembershipStatus} = this.props;

        this.setPriorMembershipStatus(priorMembershipStatus);
    }

    onChange = e => {
        this.setPriorMembershipStatus(e.target.value);
    };

    setPreferredLanguage = language => {
        BuyerInfoService.set('preferredLanguage', language);
    };

    setPriorMembershipStatus = value => {
        BuyerInfoService.set('priorMembershipStatus', value);
    };

    render() {
        const {
            priorMembershipStatus,
            question,
            onPreviousClick,
            onNextClick,
            onSaveAndExitClick
        } = this.props;

        return (
            <Step onSaveAndExitClick={onSaveAndExitClick} onPreviousClick={onPreviousClick} onNextClick={onNextClick}>
                <Form>
                    <ControlGroup>
                        <Legend>{question}</Legend>
                        <RadioGroup vertical={isMobile()}>
                            <Radio
                                name="priorMembershipStatus"
                                value="MEMBER"
                                label="Yes"
                                checked={priorMembershipStatus === 'MEMBER'}
                                onChange={this.onChange} />
                            <Radio
                                name="priorMembershipStatus"
                                value="NONMEMBER"
                                label="No"
                                checked={priorMembershipStatus !== 'MEMBER'}
                                onChange={this.onChange} />
                        </RadioGroup>
                    </ControlGroup>
                </Form>
            </Step>
        );
    }
}

const mapStateToProps = () => {
    const buyerInfo = BuyerInfoService.getBuyerInfoForCurrentApplicant();
    const {priorMembershipStatus} = buyerInfo;
    const question = CreditorService.getPriorMembershipQuestion();

    return {
        priorMembershipStatus,
        question
    };
};

const part = 'priorMembership';
const mapDispatchToProps = dispatch => {
    return {
        onPreviousClick: () => {
            dispatch(() => {
                NavigationService.next('additionalIncome');
                ApiService.save(part);
            });
        },
        onSaveAndExitClick: () => {
            ApiService.explicitSave(part);
        },
        onReviewClick: () => {
            NavigationService.next('finalReview');
        },
        onNextClick: () => {
            ApiService.save(part).then(() => {
                UIService.stepCompleted(part);
                NavigationService.next('finalReview');
            });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PriorMembership);

